import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DocumentSchema, SchemaField } from 'src/app/modules/management/store/data';

@Component({
    selector: 'topo-field-select-modal',
    templateUrl: './field-select-modal.component.html',
    styleUrls: ['./field-select-modal.component.scss'],
    standalone: false
})
export class FieldSelectModalComponent {
  @Input() isActive: boolean;
  @Input() schema: DocumentSchema;
  @Input() lookupTargetSchemaFields: SchemaField[];
  schemaFields: SchemaField[];
  @Input() showFieldSelect: boolean;
  @Output() fieldResponse = new EventEmitter<boolean>();
  @Output() selectedFieldResponse = new EventEmitter<string>();
  selectedField: string;

  constructor() { }

  cancelClick(): void {
    this.close();
  }

  saveClick() {
    this.selectedFieldResponse.emit(this.selectedField);
    this.close();
  }

  close(): void {
    this.fieldResponse.emit(false);
  }
}

